import { render, staticRenderFns } from "./remove-respondent-popup.vue?vue&type=template&id=b7ed19fe&lang=pug&"
import script from "./remove-respondent-popup.vue?vue&type=script&lang=js&"
export * from "./remove-respondent-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports